<template>
  <div>
    <DxPopup
      :visible="popupVisible"
      :drag-enabled="true"
      :hide-on-outside-click="false"
      :show-title="true"
      :width="'75%'"
      :height="680"
      :title="'Product Search'"
      @hidden="popupHidden"
      :showCloseButton="false"
      :wrapper-attr="{
        class: 'gc-popup-search-for-multiple-item css-v2 gc-popup',
      }"
    >
      <div class="search-products">
        <div class="css-v2 transaction-list">
          <dx-data-grid
            v-if="popupVisible"
            :data-source="dataSource"
            :columns="columns"
            :height="580"
            :columnChooser="{
              enabled: false,
            }"
            @selection-changed="onProductSelectionChanged"
          >
            <DxSelection
              :select-all-mode="'allPages'"
              :show-check-boxes-mode="'always'"
              mode="multiple"
              :allowSelectAll="false"
            />
            <DxPaging :page-size="50" :enabled="true" />

            <DxPager :visible="false" />

            <DxScrolling
              :mode="'virtual'"
              :row-rendering-mode="'virtual'"
              :preloadEnabled="true"
            />
          </dx-data-grid>
        </div>
      </div>

      <div class="footer edit-product-item-popup-footer">
        <DxButton
          text="Cancel"
          type="danger"
          styling-mode="contained"
          @click="popupHidden"
        />

        <DxButton
          text="Select"
          type="default"
          styling-mode="contained"
          @click="onSelectedProduct"
          :disabled="true"
          :ref="'submit-btn'"
        />
      </div>
    </DxPopup>
  </div>
</template>

<script>
// import ApiService from "../_services/api/api.service";
import BaseViewMixin from "../v1/_mixins/base.view";

export default {
  props: {
    setVisible: Boolean,
    popupHiddenCallBack: {
      type: Function,
      default: () => {},
    },
    columns: {
      type: Array,
      default: () => {},
    },
    dataSource: {
      type: Object,
      default: () => {},
    },
    setSelectedProducts: {
      type: Function,
      default: () => {},
    },
  },
  mixins: [BaseViewMixin],
  data() {
    return {
      selectedItemsData: undefined,
    };
  },
  async created() {},
  computed: {
    popupVisible() {
      return this.setVisible ? true : false;
    },
  },
  watch: {},
  methods: {
    /**
     * On product selection change
     * @param e
     */
    onProductSelectionChanged(e) {
      let submitBtn = this.$refs["submit-btn"].instance;
      if (e) {
        this.selectedItemsData = e.selectedRowsData;
      }

      if (this.selectedItemsData.length > 0) {
        submitBtn.option("disabled", false);
      } else {
        submitBtn.option("disabled", true);
      }
    },

    /**
     * on click on select button
     */
    onSelectedProduct() {
      this.setSelectedProducts(this.selectedItemsData);
      this.popupHiddenCallBack();
    },

    /**
     * closing the popup
     */
    popupHidden() {
      this.selectedItemsData = [];
      let submitBtn = this.$refs["submit-btn"].instance;
      submitBtn.option("disabled", true);
      this.popupHiddenCallBack();
    },
  },
};
</script>

<style lang="scss">
.gc-popup-search-for-multiple-item {
  .footer {
    .dx-button:first-child {
      margin-right: 12px;
    }
  }
}
</style>
